<template>
	<div class="main" v-title data-title="零部件询价记录">
		<iHeader></iHeader>
		<div class="flexRow justBetween barprebox mt25">
			<vnav></vnav>
			<div class="contR bgwhite">
				<div class="mt25 ml20">
					<div class="Ctitle">
						<h1 class="color1 font18 item1">询价记录</h1>
					</div>
				</div>
				<div class="formW itemPD">
					<el-form ref="form" :model="form" label-width="80px">
						<el-form-item label="询价单号">
							<el-input v-model="form.trade_sn"></el-input>
						</el-form-item>
						<el-form-item label="询价日期" class="w430">
							<el-date-picker v-model="form.date" type="daterange" range-separator="至" start-placeholder="开始日期"
							 end-placeholder="结束日期" @change="onPick">
							</el-date-picker>
						</el-form-item>
						<el-form-item label="询价状态" class="w240">
							<el-select v-model="form.status" placeholder="询价状态" @change="status">
								<el-option label="全部" value="0"></el-option>
								<el-option label="未回复" value="1"></el-option>
								<el-option label="已回复" value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="产品型号">
							<el-input v-model="form.xinghao"></el-input>
						</el-form-item>
						<el-form-item label="产品名称">
							<el-input v-model="form.title"></el-input>
						</el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form>
					<el-table :data="inquirylist" border style="width: 100%">
						<el-table-column prop="id" label="编号" width="120">
						</el-table-column>
						<el-table-column prop="trade_sn" label="询价单号" width="120">
						</el-table-column>
						<el-table-column prop="create_time" label="询价日期" width="150">
						</el-table-column>
						<el-table-column prop="name" label="供应商/品牌" width="120">
						</el-table-column>
						<el-table-column prop="title" label="产品名" width="120">
						</el-table-column>
						<el-table-column prop="project_model" label="型号" width="300">
						</el-table-column>
						<el-table-column prop="project_num" label="数量" width="120">
						</el-table-column>
						<el-table-column prop="is_status" label="状态" width="120">
							<template slot-scope="scope">
								<!-- <el-button @click="handleClick(scope.row)" type="text" size="small">查看</el-button> -->
								<div>{{scope.row.is_status==0?'未回复':'已回复'}}</div>
							</template>
						</el-table-column>
						<el-table-column fixed="right" label="操作" width="100">
							<template slot-scope="scope">
								<el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<v-footer></v-footer>
	</div>
</template>

<script>
	// 公共头部组件
	import iHeader from "@/components/indexheader"
	import vnav from "@/components/leftnav"
	import vFooter from "@/components/Footer"
	import VDistpicker from 'v-distpicker'
	import "@/assets/cont-01.css";
	import Vue from 'vue';
	import axios from 'axios';
	Vue.prototype.$axios = axios;
	export default {
		components: {
			iHeader,
			vFooter,
			VDistpicker,
			vnav,
		},
		data() {
			return {
				form: {
					trade_sn: '',
					date: '',
					status: '0',
					xinghao: '',
					title: ''
				},
				titleDec: "",
				inquirylist: [],
				date1: '',
				date2: ''
			};
		},
		created() {
			this.inquirylistdata();
		},
		methods: {
			getTime(time) {
				var date = new Date(time)
				var y = date.getFullYear()
				var m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1)
				var d = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate())
				return y + '-' + m + '-' + d
			},
			handleClick(row) {
				// console.log(row);
			},
			onPick(e) {
				// console.log(e[0]);
				this.date1 = this.getTime(e[0]);
				this.date2 = this.getTime(e[1]);
			},
			status(e) {
				this.form.status = e
				// console.log(e);
			},
			onSubmit() {
				// console.log('submit!');
				this.$postcn('partshome/inquirylist', {
					'project_model': this.form.xinghao,
					'addtime_start': this.date1,
					'addtime_end': this.date2,
					'trade_sn': this.form.trade_sn,
					'is_status': this.form.status,
					'title': this.form.title
				}, this).then((res) => {
					// console.log(res);
					if (res.status == 200) {
						this.inquirylist = res.data
						// console.log(this.inquirylist);
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			inquirylistdata() {
				this.$postcn('partshome/inquirylist', {}, this).then((res) => {
					// console.log(res);
					if (res.status == 200) {
						this.inquirylist = res.data
						// console.log(this.inquirylist);
					} else {
						this.$message({
							type: 'error',
							message: '数据错误'
						});
					}
				})
			},
			handleDelete(index,row) {
				this.$confirm('确定要删除该用户吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 调取接口
					this.$post('partshome/inquirydel',{id:row.id},this).then((res) => {
						if (res.status == 200) {
							this.$message({
								type: 'error',
								message: "删除成功"
							});
							this.onSubmit();
						} else {
							this.$message({
								type: 'error',
								message:"删除失败"
							});
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}
		}
	}

</script>

<style style="scoped">
	.item1 {
		display: inline-block;
	}

	.Ctitle {
		height: 35px;
		line-height: 35px;
		vertical-align: middle;
		margin-right: 20px;
		border-bottom: 1px solid #ccc;
	}

	.formW {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.inputW {
		width: 200PX;
	}

	.w430 {
		width: 430px !important;
	}

	.w240 {
		width: 240px !important;
	}

	.el-input--mini .el-input__inner {
		line-height: 38PX !important;
		height: 38PX !important;
		padding-left: 10PX;
		width: 150PX;
	}

	.itemPD .el-form-item {
		margin-bottom: 22px;
		width: 353px;
		display: inline-block;
	}
</style>



// WEBPACK FOOTER //
// src/pages/people/inquiryrecord.vue